import React from "react";
import AccountProfileForm from "@/components/AccountProfileForm";

export default function AccountSettings() {
  return (
    <div className="fade-up space-y-6" data-testid="account-settings-page">
      <p className="text-sm text-muted-foreground">
        Ubah username, nama, nomor WhatsApp, dan password akun Anda. Perubahan username & password wajib memakai password lama.
      </p>
      <AccountProfileForm className="max-w-2xl" />
    </div>
  );
}
